module.exports = __webpack_public_path__ + "assets/c223513ccac338c016bfe0f4dfc6f23c.svg";